<template>
	<main class="evaluation-sheet" v-loading="loading">
		<div class="notice" v-if="$store.state.user.userInfo.teacher.is_supervisor && statistics.length">
			<div class="content">
				<svg class="icon" aria-hidden="true">
					<use xlink:href="#icon-iconfillstate"></use>
				</svg>
				<span>有年级需要最终您进行统计评级与公布</span>
			</div>
			<el-button type="primary" size="small" @click="FinalRatingDialogVisible = true">查看</el-button>
		</div>
		<div class="filter-area">
			<el-form ref="filter_form" :model="filter_form" label-width="80px" :inline="true" @submit.native.prevent>
				<el-form-item>
					<el-select
						v-model="filter_form.classgradeFilter"
						placeholder="请选择班级"
						@change="calssgradeChange"
						filterable
					>
						<el-option
							v-for="item in classgradeList"
							:key="item.id"
							:label="item.class_name"
							:value="item.id"
						></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-select v-model="filter_form.semesterFilter" placeholder="选择学期" @change="refreshList()" filterable>
						<el-option
							v-for="(item, index) in semesterList"
							:key="index"
							:label="`${item.name}${index === 0 ? '' : '（往期）'}`"
							:value="index"
						></el-option>
					</el-select>
				</el-form-item>

				<div class="button-group" v-if="evaluationTemplate">
					<template v-if="filter_form.semesterFilter === 0">
						<el-button @click="exportTemplate">下载Excel模版</el-button>
						<el-upload class="upload-demo" action="#" :show-file-list="false" :http-request="importEvaluation">
							<el-button>从Excel导入数据</el-button>
						</el-upload>
					</template>
					<el-button type="primary" @click="prizeDialogVisible = true">查看奖项榜</el-button>
				</div>
			</el-form>
		</div>
		<div class="table-block">
			<el-table :data="tableData" class="el-table--border">
				<el-table-column fixed prop="account.realname" label="学生" :width="l3IndicatorStudentWidth">
					<template v-slot:default="slot">
						<el-tooltip
							class="item"
							effect="dark"
							content="查看学生详情"
							placement="top"
							:enterable="false"
							:open-delay="200"
						>
							<div
								class="table-cell hover"
								@click="
									$router.push({
										name: 'evaluationStudentView',
										params: { id: slot.row.account.id }
									})
								"
							>
								{{ slot.row.number_in_class + slot.row.account.realname }}
							</div>
						</el-tooltip>
					</template>
				</el-table-column>
				<template v-if="evaluationTemplate">
					<el-table-column
						v-for="(levae1, index1) in evaluationTemplate.indicators"
						:key="'levae1' + index1"
						:label="levae1.label"
						align="center"
					>
						<el-table-column
							v-for="(levae2, index2) in levae1.children"
							:key="'levae2' + index2"
							:label="levae2.label"
							align="center"
						>
							<el-table-column
								v-for="(levae3, index3) in levae2.children"
								:key="'levae3' + index3"
								:label="levae3.name"
								align="center"
							>
								<template v-slot:default="slot">
									<el-tooltip
										v-if="getMetricsValue(slot.row, levae3)"
										class="item"
										effect="dark"
										content="查看详情"
										placement="top"
										:enterable="false"
										:open-delay="200"
									>
										<div class="table-cell hover" @click="setMetricsGrade(slot.row, levae3)">
											{{ getMetricsValue(slot.row, levae3) }}
										</div>
									</el-tooltip>
									<div @click="setMetricsGrade(slot.row, levae3)" class="set-grade table-cell" v-else>
										{{
											levae3.mapping_rule.allow_modify_level && filter_form.semesterFilter === 0
												? '点击评级'
												: '暂无评级'
										}}
									</div>
								</template>
							</el-table-column>
						</el-table-column>
					</el-table-column>
					<el-table-column
						:width="l3IndicatorFinalRatingWidth"
						fixed="right"
						align="center"
						:key="'final-rating' + rankedDistributionKey"
						v-if="evaluationTemplate"
					>
						<template slot="header">
							<span>最终评级</span>
							<el-tooltip class="item" effect="dark" placement="right" ref="mypop">
								<div slot="content" style="line-height: 17px;">
									<template
										v-if="
											evaluationTemplate.ranking_rule.type === $api.evaluation_system.rankingType.GRADE_RATE.vaue &&
											rankedDistribution.null === tableData.length
										"
									>
										最终由学科长进行统计
									</template>
									<template v-else>
										未评定：{{ rankedDistribution.null }}人<br />等级A：{{ this.rankedDistribution.A }}人<br />等级B：{{
											this.rankedDistribution.B
										}}人<br />等级C：{{ this.rankedDistribution.C }}人<br />等级D：{{
											this.rankedDistribution.D
										}}人<br />等级E：{{ this.rankedDistribution.E }}人
									</template>
								</div>
								<div
									class="statistics"
									style="color: #ffac2d;"
									v-if="
										evaluationTemplate.ranking_rule.type === $api.evaluation_system.rankingType.GRADE_RATE.vaue &&
										rankedDistribution.null === tableData.length
									"
								>
									等待统计
								</div>
								<div v-else class="statistics">统计信息</div>
							</el-tooltip>
						</template>
						<template v-slot:default="slot">
							<el-dropdown
								v-if="
									evaluationTemplate.ranking_rule.allow_modify_level &&
									filter_form.semesterFilter === 0 &&
									tableData[0].evaluation.state === $api.student_evaluation.evaluationState.DRAFT.value
								"
								@command="finalRating($event, slot.row)"
								trigger="click"
								placement="bottom"
							>
								<div
									class="set-grade table-cell final-grade"
									:style="`color:${slot.row.evaluation.grade ? '#666' : '#ccc'}`"
								>
									<span> {{ slot.row.evaluation.grade || '点击评级' }} </span>
								</div>
								<el-dropdown-menu slot="dropdown" class="evaluation-sheet-dropdown">
									<el-dropdown-item
										v-for="grade in $api.evaluation_system.levelType.list"
										:key="'dropdown-grade' + grade"
										:command="grade"
										>{{ grade }}</el-dropdown-item
									>
								</el-dropdown-menu>
							</el-dropdown>
							<div v-else-if="slot.row.evaluation.grade" class="table-cell">
								{{ slot.row.evaluation.grade }}
							</div>
							<div
								v-else-if="
									evaluationTemplate.ranking_rule.type === $api.evaluation_system.rankingType.GRADE_RATE.vaue &&
									rankedDistribution.null === tableData.length
								"
							>
								等待统计
							</div>
							<div class="table-cell not-grade" v-else>暂无评级</div>
						</template>
					</el-table-column>
				</template>
				<div v-else class="empty-data">暂无评估表</div>
			</el-table>
			<!-- 自定义滚动条 -->
			<div class="scrollbar" v-if="evaluationTemplate && evaluationTemplate.indicators">
				<span class="dragbar"></span>
			</div>
		</div>

		<!-- 仿写三级指标头 -->
		<div id="l3-indicator_fixed" class="shadow-right" v-if="evaluationTemplate && evaluationTemplate.indicators">
			<div class="student" :style="`width:${l3IndicatorStudentWidth}px`">
				学生
			</div>
			<div class="l3-indicator_wrapper">
				<div class="l3-indicator">
					<template v-for="levae1 in evaluationTemplate.indicators">
						<template v-for="levae2 in levae1.children">
							<template v-for="levae3 in levae2.children">
								<div class="cell" :key="'l3-indicator_tr' + levae3.id">
									{{ levae3.name }}
								</div>
							</template>
						</template>
					</template>
				</div>
			</div>
			<div class="final-rating" :style="`width:${l3IndicatorFinalRatingWidth}px`">
				<span>最终评级</span>
				<el-tooltip class="item" effect="dark" placement="right" ref="mypop">
					<div slot="content" style="line-height: 17px;">
						<template
							v-if="
								evaluationTemplate.ranking_rule.type === $api.evaluation_system.rankingType.GRADE_RATE.vaue &&
								rankedDistribution.null === tableData.length
							"
						>
							最终由学科长进行统计
						</template>
						<template v-else>
							未评定：{{ rankedDistribution.null }}人<br />等级A：{{ this.rankedDistribution.A }}人<br />等级B：{{
								this.rankedDistribution.B
							}}人<br />等级C：{{ this.rankedDistribution.C }}人<br />等级D：{{
								this.rankedDistribution.D
							}}人<br />等级E：{{ this.rankedDistribution.E }}人
						</template>
					</div>
					<div
						class="statistics"
						style="color: #ffac2d;"
						v-if="
							evaluationTemplate.ranking_rule.type === $api.evaluation_system.rankingType.GRADE_RATE.vaue &&
							rankedDistribution.null === tableData.length
						"
					>
						等待统计
					</div>
					<div v-else class="statistics">统计信息</div>
				</el-tooltip>
			</div>
		</div>

		<div class="publish" v-if="evaluationTemplate && filter_form.semesterFilter === 0">
			<el-tooltip
				v-if="tableData[0].evaluation.state === $api.student_evaluation.evaluationState.DRAFT.value"
				:disabled="
					evaluationTemplate.ranking_rule.type != $api.evaluation_system.rankingType.GRADE_RATE.value &&
					releasableEvaluation
				"
				class="item"
				effect="dark"
				:content="
					evaluationTemplate.ranking_rule.type === $api.evaluation_system.rankingType.GRADE_RATE.value
						? releasableEvaluation
							? '确认评估表后，等待学科长公布'
							: '无法确认，存在未完成评级的指标'
						: '无法发布，存在未完成评级的指标'
				"
				placement="top"
			>
				<div>
					<el-button
						v-if="evaluationTemplate.ranking_rule.type === $api.evaluation_system.rankingType.GRADE_RATE.value"
						:disabled="!releasableEvaluation"
						type="primary"
						@click="confirmEvaluation"
						>确认评估表</el-button
					>
					<el-button v-else :disabled="!releasableEvaluation" type="primary" @click="publishEvaluation">
						公布评估表</el-button
					>
				</div>
			</el-tooltip>

			<template
				v-else-if="evaluationTemplate.ranking_rule.type === $api.evaluation_system.rankingType.GRADE_RATE.value"
			>
				<el-button
					v-if="tableData[0].evaluation.state === $api.student_evaluation.evaluationState.CONFIRMED.value"
					class="rollback"
					type="warning"
					@click="rollbackEvaluation('撤回确认评估表，将会导致学科长无法统计年级最终评级，确定撤回？', '撤回确认')"
				>
					<div class="content">
						<template>
							<template>
								<svg class="icon" aria-hidden="true">
									<use xlink:href="#icon-iconoutlinedel"></use>
								</svg>
								<span>撤回确认</span>
							</template>
						</template>
					</div>
				</el-button>
			</template>
			<el-button
				class="rollback"
				v-else
				type="warning"
				@click="rollbackEvaluation('评估表撤回后，学生看到的评级将一并撤回，确定撤回评估表？', '撤回评估表')"
			>
				<svg class="icon" aria-hidden="true">
					<use xlink:href="#icon-iconoutlinerestart"></use>
				</svg>
				<span>撤回评估表</span>
			</el-button>
		</div>

		<el-drawer
			class="evaluation-sheet-drawer"
			:size="600"
			:title="currentRatingObject.studentInfo ? currentRatingObject.studentInfo.account.realname : ''"
			@open="evaluationDrawerOpened"
			@close="submitRating"
			:visible.sync="evaluationDrawer"
			:modal-append-to-body="false"
		>
			<div class="drawer-content" v-if="evaluateDetail.evaluation_indicator">
				<div class="rating-rules">
					<div class="rating-rules-header">
						<svg class="icon" aria-hidden="true">
							<use xlink:href="#icon-iconoutlinetarget"></use>
						</svg>
						<div class="text">
							<span class="name"
								>{{ evaluateDetail.evaluation_indicator.name }}（{{
									evaluateDetail.evaluation_indicator.total_score
								}}）</span
							>
							<span class="describe">{{ evaluateDetail.evaluation_indicator.description }}</span>
						</div>
					</div>
					<!-- 只在手动评级与申报展示规则 -->
					<div
						class="rating-rules-content"
						v-if="
							evaluateDetail.evaluation_indicator.type === $api.evaluation_system.l3Type.PERFORMANCE.value ||
							evaluateDetail.evaluation_indicator.type === $api.evaluation_system.l3Type.DECLARATION.value
						"
					>
						<span class="title">评分规则</span>
						<ul class="rating-rules-details">
							<template
								v-if="evaluateDetail.evaluation_indicator.type === $api.evaluation_system.l3Type.DECLARATION.value"
							>
								<li
									v-if="
										evaluateDetail.evaluation_indicator.declaration_process.process_type ===
										$api.evaluation_system.processType.GET_GRADE.value
									"
								>
									申报通过后，申报内评定的等级作为评级等级
								</li>
								<template
									v-if="
										evaluateDetail.evaluation_indicator.declaration_process.process_type ===
										$api.evaluation_system.processType.ADD_SCORE.value
									"
								>
									<li>
										每条有效申报得{{
											evaluateDetail.evaluation_indicator.declaration_process.process_extras.unit_score
										}}分
									</li>
									<li
										v-for="(value, name, index) in evaluateDetail.evaluation_indicator.mapping_rule.rules"
										:key="'declaration-process' + index"
									>
										<span v-if="value != -1">{{ '申报分数达到 ' + value + ' 分时，评价等级为 ' + name }}</span>
										<span v-else>{{ '其他情况，指标等级 ' + name }}</span>
									</li>
								</template>
							</template>
							<template
								v-if="evaluateDetail.evaluation_indicator.type === $api.evaluation_system.l3Type.PERFORMANCE.value"
							>
								<li
									v-for="(value, name, index) in evaluateDetail.evaluation_indicator.mapping_rule.rules"
									:key="'rule' + index"
								>
									<span v-if="value != -1">{{ '学生表现分达 ' + value + ' 分时，对应指标等级为 ' + name }}</span>
									<span v-else>{{ '其他情况，对应指标等级 ' + name }}</span>
								</li>
							</template>
						</ul>
					</div>
				</div>

				<!-- 学生表现特有 -->
				<template v-if="evaluateDetail.evaluation_indicator.type === $api.evaluation_system.l3Type.PERFORMANCE.value">
					<div class="performance-section">
						<div class="performance-block">
							<div class="performance-header">加减分规则</div>
							<div class="content rules">
								<div class="reduce">
									<template v-for="(rule, index) in evaluateDetail.evaluation_indicator.extras.score_rule">
										<div
											class="item"
											:key="'reduce' + index"
											v-if="rule.type === $api.student_evaluation.algorithm.REDUCE.value"
										>
											<span>{{ rule.name }}</span>
											<span class="score">- {{ rule.score }}分</span>
										</div>
									</template>
								</div>
								<div class="plus">
									<template v-for="(rule, index) in evaluateDetail.evaluation_indicator.extras.score_rule">
										<div
											class="item"
											:key="'plus' + index"
											v-if="rule.type === $api.student_evaluation.algorithm.PLUS.value"
										>
											<span>{{ rule.name }}</span>
											<span class="score">+ {{ rule.score }}分</span>
										</div>
									</template>
								</div>
							</div>
						</div>
						<div class="performance-block">
							<div class="performance-header">
								表现记录统计（初始{{ evaluateDetail.evaluation_indicator.extras.original_score }}分）
							</div>
							<template v-if="evaluateDetail.source && evaluateDetail.source.entities.length">
								<div class="content record">
									<div class="item" v-for="(item, index) in evaluateDetail.source.entities" :key="'record' + index">
										<div class="name">{{ item.performance }}</div>
										<div class="count">{{ item.count }}次</div>
										<div
											:class="{
												score: true,
												reduce: item.type === $api.student_evaluation.algorithm.REDUCE.value,
												plus: item.type === $api.student_evaluation.algorithm.PLUS.value
											}"
										>
											{{ item.type === $api.student_evaluation.algorithm.REDUCE.value ? '-' : '+' }}
											{{ item.score }}分
										</div>
									</div>
								</div>
								<div class="performance-footer">
									<div class="footer-text">最终表现分</div>
									<div class="total-score">{{ evaluateDetail.score }}</div>
								</div>
							</template>
							<div v-else class="empty-data">暂无加减分记录</div>
						</div>
					</div>
				</template>

				<el-form :model="evaluateDetail">
					<!-- 申报特有 -->
					<template v-if="evaluateDetail.evaluation_indicator.type === $api.evaluation_system.l3Type.DECLARATION.value">
						<el-form-item
							label="申报记录"
							label-width="100px"
							class="record"
							v-if="evaluateDetail.source && declarationRecord(evaluateDetail.source.entities)"
						>
							<template v-for="(ev, index) in evaluateDetail.source.entities">
								<div
									class="recordItem"
									:key="'ev' + index"
									v-if="ev.entity.state === $api.declaration.state.COMPLETED.value"
								>
									<div class="info">
										<span class="date">{{ ev.entity.created_at }}</span>
										<span
											:class="{
												name: true,
												event: ev.author_uid === $store.state.user.userInfo.id
											}"
											@click="toEntityDetail(ev)"
											>{{ ev.entity.name }}
											<svg class="icon" aria-hidden="true">
												<use xlink:href="#icon-iconfilleye"></use>
											</svg>
										</span>
									</div>
									<div
										class="grade"
										v-if="
											evaluateDetail.evaluation_indicator.declaration_process.process_type ===
											$api.evaluation_system.processType.GET_GRADE.value
										"
									>
										申报评级：{{ ev.entity.grade }}
									</div>
									<div
										class="score"
										v-if="
											evaluateDetail.evaluation_indicator.declaration_process.process_type ===
											$api.evaluation_system.processType.ADD_SCORE.value
										"
									>
										+
										{{ evaluateDetail.evaluation_indicator.declaration_process.process_extras.unit_score }}分
									</div>
								</div>
							</template>
						</el-form-item>
						<div v-else class="empty-data">暂无申报记录</div>
					</template>

					<!-- 评测 -->
					<template
						v-if="
							(evaluateDetail.evaluation_indicator.type === $api.evaluation_system.l3Type.EXAM.value ||
								evaluateDetail.evaluation_indicator.type === $api.evaluation_system.l3Type.DAILY_TEST.value) &&
							evaluateDetail.source
						"
					>
						<el-form-item
							label="评测记录"
							label-width="100px"
							class="record"
							v-if="evaluateDetail.source.entities.length"
						>
							<template v-for="(ts, index) in evaluateDetail.source.entities">
								<div class="recordItem" :key="'ts' + index">
									<div class="info">
										<span class="date">{{ ts.datetime }}</span>
										<span
											:class="{
												name: true,
												event: true
											}"
											@click="toEntityDetail(ts)"
											>{{ ts.test_name }}
											<svg class="icon" aria-hidden="true">
												<use xlink:href="#icon-iconfilleye"></use>
											</svg>
										</span>
									</div>
								</div>
							</template>
						</el-form-item>
						<div v-else class="empty-data">暂无评测记录</div>
					</template>

					<!-- 练习单 -->
					<div
						class="rating-rules-content homework"
						v-if="evaluateDetail.evaluation_indicator.type === $api.evaluation_system.l3Type.HOMEWORK.value"
					>
						<span class="title">练习规则</span>
						<ul class="rating-rules-details">
							<li
								v-for="(rules, index) in evaluateDetail.evaluation_indicator.extras.score_mapping"
								:key="'homework-rules' + index"
								:class="{ reach: rules.grade === evaluateDetail.grade }"
							>
								<span>{{
									'练习单获得 ' +
									rules.homework_number +
									' 个以上 ' +
									rules.homework_grade +
									' 级达标，指标等级为 ' +
									rules.grade
								}}</span>
								<span class="reach" v-if="rules.grade === evaluateDetail.grade">
									<svg class="icon" aria-hidden="true">
										<use xlink:href="#icon-iconfillsubmit"></use>
									</svg>
									<span>已达成</span>
								</span>
							</li>
						</ul>
					</div>

					<el-form-item
						v-if="
							evaluateDetail.evaluation_indicator.type === $api.evaluation_system.l3Type.MANUAL_RATING.value &&
							evaluateDetail.evaluation_indicator.mapping_rule.allow_modify_level
						"
						label="评语"
						label-width="100px"
					>
						<el-input
							@focus="chaeckEvaluationState"
							:disabled="filter_form.semesterFilter != 0"
							type="textarea"
							placeholder="简单评价一下学生（选填）"
							:rows="5"
							v-model="evaluateDetail.comment"
						></el-input>
					</el-form-item>
					<div class="drawer-footer">
						<el-form-item
							label="评价等级"
							v-if="
								filter_form.semesterFilter === 0 && evaluateDetail.evaluation_indicator.mapping_rule.allow_modify_level
							"
							label-width="100px"
						>
							<el-select
								@focus="chaeckEvaluationState"
								v-model="evaluateDetail.grade"
								placeholder="请选择"
								style="width: 100%;"
							>
								<el-option
									v-for="grade in $api.evaluation_system.levelType.list"
									:key="'grade' + grade"
									:label="grade + gradeLabelExtra(grade)"
									:value="grade"
								>
								</el-option>
							</el-select>
						</el-form-item>
						<div label="评价等级：" v-else class="grade">
							<span v-if="evaluateDetail.grade">评价等级：{{ evaluateDetail.grade }}</span>
							<template v-else>
								<span v-if="evaluateDetail.evaluation_indicator.type === $api.evaluation_system.l3Type.HOMEWORK.value"
									>暂无评级，练习次数或等级不足</span
								>
								<span
									v-if="
										evaluateDetail.evaluation_indicator.type === $api.evaluation_system.l3Type.DAILY_TEST.value ||
										evaluateDetail.evaluation_indicator.type === $api.evaluation_system.l3Type.EXAM.value
									"
									>暂无评级，评测结束后公布评级</span
								>
								<span
									v-if="evaluateDetail.evaluation_indicator.type === $api.evaluation_system.l3Type.DECLARATION.value"
									>暂无评级，申报完成后进行评级</span
								>
								<span
									v-if="evaluateDetail.evaluation_indicator.type === $api.evaluation_system.l3Type.PERFORMANCE.value"
								>
									暂无评级</span
								>
							</template>
						</div>
						<el-button @click="evaluationDrawer = false" :disabled="!evaluateDetail.grade" type="primary"
							>确定</el-button
						>
					</div>
				</el-form>
			</div>
		</el-drawer>

		<el-dialog class="prize-dialog" title="奖项榜" :visible.sync="prizeDialogVisible" width="800px">
			<div class="content" v-if="evaluationTemplate && evaluationTemplate.awards.length">
				<div class="item" v-for="(award, index) in evaluationTemplate.awards" :key="'award' + index">
					<div class="top">
						<span class="prize-name">
							<svg class="icon" aria-hidden="true">
								<use xlink:href="#icon-iconfilltrophy"></use>
							</svg>
							{{ award.name }}
						</span>
						<span class="vertical-split"></span>
						<span class="prize-standard">{{ award.indicator_name }} · 指标等级为 {{ award.grade }}</span>
					</div>
					<div class="name-list" v-if="award.students.length">
						<template v-for="(student, index) in award.students">
							<span :key="'student' + index">{{ student }}</span>
						</template>
					</div>
					<div class="empty" v-else>
						<span>暂无人获奖</span>
					</div>
				</div>
			</div>
			<div v-else class="empty-data" style="margin: 16px 0;">暂无奖项</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="prizeDialogVisible = false">我知道了</el-button>
			</span>
		</el-dialog>

		<el-dialog
			class="final-rating-dialog"
			title="年级最终评级"
			:visible.sync="FinalRatingDialogVisible"
			@open="checkStatistics"
			@close="endStatistics"
			width="600px"
		>
			<div class="content">
				<div class="tips">
					<svg class="icon" aria-hidden="true">
						<use xlink:href="#icon-iconfillsubmit"></use>
					</svg>
					<span>以下年级评估表的最终评级按年级排名进行评级，需要由学科长最后进行统计评级与公布</span>
				</div>
				<div class="item" v-for="(item, index) in statistics" :key="'statistic' + index">
					<div class="basic">
						<div class="grade">
							<svg class="icon" aria-hidden="true">
								<use xlink:href="#icon-users"></use>
							</svg>
							<span>{{ $api.classgrade.grades.toText(item.grade) }}</span>
						</div>
						<div class="state">
							<el-button
								@click="statisticsGrade(item.grade)"
								v-if="
									(item.data.state_confirm && item.data.state_confirm <= item.data.total) ||
									item.data.state_filling_in ||
									(item.data.state_confirm == item.data.total && item.data.grade_count == item.data.total)
								"
								:disabled="item.data.state_filling_in > 0"
								size="medium"
								class="statistic-btn"
								>开始统计</el-button
							>
							<div
								class="in-statistics"
								v-else-if="
									item.data.state_confirm == 0 &&
									item.data.state_calculating == item.data.total &&
									item.data.grade_count == 0
								"
							>
								正在统计
							</div>
							<el-button
								@click="publishGrade(item.grade)"
								v-else-if="item.data.state_calculating == item.data.total && item.data.grade_count == item.data.total"
								type="primary"
								size="medium"
								>公布评估表</el-button
							>
							<el-button
								@click="rollbackGrade(item.grade)"
								v-else-if="item.data.state_complated == item.data.total && item.data.grade_count == item.data.total"
								type="warning"
								size="medium"
								>撤回评估表</el-button
							>
						</div>
					</div>
					<div class="extra" v-if="item.data.filling_in_class_grade.length">
						暂不可统计，以下班级暂未完成评估表评级：
						<span v-for="(grade, index2) in item.data.filling_in_class_grade" :key="'statistic-extra' + index2">
							<template v-if="index2 != 0"> ， </template>
							<span>{{ grade }}</span>
						</span>
					</div>
				</div>
			</div>
		</el-dialog>

		<el-dialog :visible.sync="importFailedDialogVisible" width="600px" class="import-failed-dialog">
			<div slot="title">
				<svg class="icon" aria-hidden="true">
					<use xlink:href="#icon-iconfilldel"></use>
				</svg>
				<span>导入失败</span>
			</div>
			<p style="white-space: pre-wrap;">{{ importFailedMessage }}</p>
			<template slot="footer">
				<el-upload class="upload-demo" action="#" :show-file-list="false" :http-request="importEvaluation">
					<el-button type="primary">重新导入</el-button>
				</el-upload>
			</template>
		</el-dialog>
	</main>
</template>
<script>
import $ from 'jquery'

var mousedown_x
var mousemove_x
var dragbar_offsetX

var dragbarpressdown_position
var dragbar_position_end

let statisticsTimer = null

export default {
	name: 'evaluationSheet',
	data() {
		return {
			prizeDialogVisible: false,
			FinalRatingDialogVisible: false,
			importFailedDialogVisible: false,
			importFailedMessage: '',
			filter_form: {
				classgradeFilter: null,
				semesterFilter: null
			},
			semesterList: [],
			tableData: [],
			statistics: [],
			classgradeList: [],
			evaluationTemplate: null,
			rankedDistribution: null,
			evaluationDrawer: false,
			evaluateDetail: {
				grade: null,
				comment: null
			},
			currentRatingObject: {
				studentInfo: null,
				indicators: null
			},
			rankedDistributionKey: 0,
			scrollStart: null,
			scrollEnd: null,
			scrollDraging: false,
			l3IndicatorStudentWidth: 150,
			l3IndicatorFinalRatingWidth: 100,
			loading: false
		}
	},
	computed: {
		releasableEvaluation() {
			const indicators = this.evaluationTemplate.indicators
			for (let l1 of indicators) {
				for (let l2 of l1.children) {
					for (let l3 of l2.children) {
						if (l3.type === this.$api.evaluation_system.l3Type.MANUAL_RATING.value) {
							for (let student of this.tableData) {
								const result = student.metrics.find(el => el.evaluation_indicator_id === l3.id)
								// 手动评级以及最终评级手动评级类型未评级时，禁用发布按钮
								if (
									!result.grade ||
									(this.evaluationTemplate.ranking_rule.allow_modify_level && !student.evaluation.grade)
								) {
									return false
								}
							}
						}
					}
				}
			}
			return true
		}
	},
	async created() {
		this.$emit('breadcrumbChange', [])
		if (this.$store.state.user.userInfo.teacher.is_supervisor) {
			let res = await this.$api.classgrade.list({
				filterBy: {
					school_id: this.$store.state.user.userInfo.teacher.school_id
				},
				has_students: true
			})
			this.classgradeList = res.data
		} else {
			this.classgradeList = this.$store.state.user.userInfo.teacher.class_grades
		}
		// 默认选上第一个班级
		this.filter_form.classgradeFilter = this.classgradeList[0].id

		// 学期数据
		await this.refreshSemester()
		// 默认选上第一个学期
		this.filter_form.semesterFilter = 0

		this.refreshList()

		// 学科长检查是否有待统计的年级
		if (this.$store.state.user.userInfo.teacher.is_supervisor) {
			this.refreshStatistics()
		}

		window.addEventListener('scroll', this.handleScroll, true)
	},
	methods: {
		async refreshList(state) {
			this.loading = true
			var scrollbar = $('.scrollbar')
			scrollbar.css('display', 'none')
			try {
				let res = await this.$api.classgrade.getEvaluations(this.filter_form.classgradeFilter, {
					subject_id: this.$store.state.user.userInfo.teacher.subject_id,
					year: this.semesterList.length ? this.semesterList[this.filter_form.semesterFilter].year : null,
					semester: this.semesterList.length ? this.semesterList[this.filter_form.semesterFilter].semester : null
				})
				this.tableData = res.students
				this.evaluationTemplate = res.template
				this.rankedDistribution = res.ranked_distribution
				this.rankedDistributionKey++ // el-tooltip 表现有点奇怪，需要用Key 更新视图数据
				if (state) {
					// 后端异步算分，评估表状态不会立刻改变，在这里做下手脚
					this.tableData[0].evaluation.state = state
				}
				this.loading = false
				this.$nextTick(() => {
					setTimeout(() => {
						this.setScrollBar() // 去设置自定义滚动条
					}, 1000) // 需要等 el-table 生成视图后才能执行
				})
			} catch (err) {
				this.evaluationTemplate = null
				// 没有评估模板时单独拿班级学生数据
				let students = await this.$api.student.list({
					filterBy: {
						class_grade_id: this.filter_form.classgradeFilter
					},
					paginate: {
						size: 200
					}
				})
				this.tableData = students.data
				this.loading = false
			}
		},
		async calssgradeChange() {
			await this.refreshSemester()
			this.filter_form.semesterFilter = 0
			this.refreshList()
		},
		async refreshStatistics() {
			this.statistics = await this.$api.student_evaluation.statistics()
		},
		getMetricsValue(row, levae) {
			let result = row.metrics.find(el => el.evaluation_indicator_id === levae.id)
			return result ? result.grade : null
		},
		setMetricsGrade(target, indicators) {
			this.evaluationDrawer = true
			this.currentRatingObject = {
				studentInfo: target,
				metric: target.metrics.find(el => el.evaluation_indicator_id === indicators.id), // 找对应的指标信息
				indicators: indicators
			}
		},
		async submitRating() {
			if (
				this.tableData[0].evaluation.state != this.$api.student_evaluation.evaluationState.DRAFT.value ||
				!this.evaluateDetail.evaluation_indicator.mapping_rule.allow_modify_level ||
				!this.evaluateDetail.grade
			)
				return
			await this.$api.student_evaluation.rating(
				this.currentRatingObject.studentInfo.evaluation.id,
				this.currentRatingObject.indicators.id,
				{
					grade: this.evaluateDetail.grade,
					comment: this.evaluateDetail.comment
				}
			)
			this.evaluationDrawer = false
			this.evaluateDetail = {
				grade: '',
				comment: ''
			}
			this.refreshList()
		},
		async finalRating(grade, target) {
			await this.$api.student_evaluation.final_rating(target.evaluation.id, {
				grade: grade
			})
			this.refreshList()
		},
		async refreshSemester() {
			let res = await this.$api.classgrade.semesterInfo(this.filter_form.classgradeFilter)
			this.semesterList = res
		},
		async publishEvaluation() {
			await this.$confirm('评估表公布后，学生将可看到所有评级，确定公布评估表？', '公布评估表', {
				confirmButtonText: '公布',
				cancelButtonText: '取消'
			})
			await this.$api.classgrade.release_evaluation(this.filter_form.classgradeFilter, this.evaluationTemplate.id)
			this.$message.success('评估表公布成功')
			this.refreshList(this.$api.student_evaluation.evaluationState.PUBLIC.value)
		},
		async confirmEvaluation() {
			await this.$api.classgrade.release_evaluation(this.filter_form.classgradeFilter, this.evaluationTemplate.id, {
				confirm: true
			})
			this.refreshList()
		},
		checkStatistics() {
			this.refreshStatistics()
			// 检查已有可发布，存进oldReleasable
			let oldReleasable = []
			for (let item of this.statistics) {
				if (item.data.state_calculating == item.data.total && item.data.grade_count == item.data.total) {
					oldReleasable.push(item.grade)
				}
			}
			if (oldReleasable.length === this.statistics.length) return // 全部待公布状态，不需要查待统计了

			const h = this.$createElement

			statisticsTimer = setInterval(() => {
				this.refreshStatistics()
				for (let item1 of this.statistics) {
					if (item1.data.state_calculating == item1.data.total && item1.data.grade_count == item1.data.total) {
						// 在旧的队列不温馨提示
						if (!oldReleasable.find(e => e === item1.grade)) {
							const notify = this.$notify({
								title: '统计已完成',
								dangerouslyUseHTMLString: true,
								message: h('div', null, [
									h(
										'span',
										null,
										`${this.$api.classgrade.grades.toText(item1.grade)}已完成最终评级统计，是否公布评估表？`
									),
									h(
										'div',
										{
											style: 'display:flex;justify-content:flex-end;margin-top:16px;'
										},
										[
											h(
												'div',
												{
													class: 'statistics-btn',
													style: 'margin-right:12px',
													on: {
														click: () => {
															notify.close() // 销毁我自己
														}
													}
												},
												'暂不公布'
											),
											h(
												'div',
												{
													class: 'statistics-btn publish',
													on: {
														click: () => {
															this.publishGrade(item1.grade, notify)
														}
													}
												},
												'公布'
											)
										]
									)
								]),
								duration: 0,
								type: 'success'
							})
							// 温馨提示完成放进旧队列
							oldReleasable.push(item1.grade)
						}
					}
				}
			}, 1000)
		},
		endStatistics() {
			clearInterval(statisticsTimer)
			statisticsTimer = null
		},
		async rollbackEvaluation(tips, title) {
			// rollback:true 撤回评估表
			await this.$confirm(tips, title, {
				confirmButtonText: '撤回',
				cancelButtonText: '取消',
				type: 'warning'
			})
			await this.$api.classgrade.release_evaluation(this.filter_form.classgradeFilter, this.evaluationTemplate.id, {
				rollback: true
			})
			this.refreshList()
		},
		async evaluationDrawerOpened() {
			this.evaluateDetail.evaluation_indicator = null // 清理一下防止看到旧数据
			let res = await this.$api.student_evaluation.indicator_detail(
				this.currentRatingObject.studentInfo.evaluation.id,
				this.currentRatingObject.metric.evaluation_indicator_id
			)
			this.evaluateDetail = res
		},
		toEntityDetail(ev) {
			let type = this.evaluateDetail.evaluation_indicator.type
			this.evaluationDrawer = false
			switch (type) {
				case 'declaration': // 跳转通告详情
					this.$router.push({
						name: 'publicNoticeView',
						params: {
							id: ev.entity_id
						}
					})
					break
				case 'exam':
				case 'daily_test': // 跳转学生评测详情
					this.$router.push({
						name: 'teacherViewAnswerSheet',
						params: {
							sbid: this.evaluateDetail.student_evaluation.subject_id,
							seid: ev.test_serial,
							asid: ev.answersheet_id
						}
					})
					break
			}
		},
		gradeLabelExtra(grade) {
			if (this.evaluateDetail.evaluation_indicator.type === this.$api.evaluation_system.l3Type.DECLARATION.value) {
				if (
					this.evaluateDetail.evaluation_indicator.declaration_process.process_type ===
					this.$api.evaluation_system.processType.GET_GRADE.value
				) {
					if (grade === this.evaluateDetail.evaluation_indicator.declaration_process.process_extras.default_grade) {
						return ' （默认等级）'
					}
				}
			} else if (
				this.evaluateDetail.evaluation_indicator.type === this.$api.evaluation_system.l3Type.PERFORMANCE.value
			) {
				if (grade === this.evaluateDetail.grade_by_bot) {
					return ' （系统评定等级）'
				}
			}
			return ''
		},
		declarationRecord(record) {
			// 界面只展示申报完成的数据
			return record.filter(el => el.entity.state === this.$api.declaration.state.COMPLETED.value).length
		},
		async exportTemplate() {
			const blob = await this.$api.classgrade.export_evaluation_template(
				this.filter_form.classgradeFilter,
				this.evaluationTemplate.id
			)

			const url = window.URL.createObjectURL(new Blob([blob]))
			let a = document.createElement('a')
			a.href = url
			const className = this.classgradeList.find(el => el.id === this.filter_form.classgradeFilter).class_name
			const semester = this.semesterList[this.filter_form.semesterFilter].name
			a.download = `${className + semester}评估表模板.xlsx`
			a.click()
			window.URL.revokeObjectURL(url)
		},
		async importEvaluation(param) {
			this.importFailedDialogVisible = false
			let upFile = param.file
			try {
				let res = await this.$api.classgrade.import_evaluation(
					this.filter_form.classgradeFilter,
					this.evaluationTemplate.id,
					upFile
				)
				if (res.success) {
					this.$message.success('导入成功')
					this.refreshList()
				} else {
					this.importFailedMessage = res.message
					this.importFailedDialogVisible = true
				}
			} catch {
				this.$message.error('导入失败')
			}
		},
		async chaeckEvaluationState(element) {
			// 检查是否需要撤回评估表才能操作
			if (this.tableData[0].evaluation.state != this.$api.student_evaluation.evaluationState.DRAFT.value) {
				const tips =
					this.evaluationTemplate.ranking_rule.type === this.$api.evaluation_system.rankingType.GRADE_RATE.vaue
						? '评估表已经确认，如果需要修改评估信息，需要撤回评估表，确定撤回评估表？'
						: '评估表已经公布，如果需要修改评估信息，需要撤回评估表，确定撤回评估表？'
				element.target.blur()
				await this.$confirm(tips, '修改评估信息', {
					confirmButtonText: '撤回',
					cancelButtonText: '取消',
					type: 'warning'
				})
				await this.$api.classgrade.release_evaluation(this.filter_form.classgradeFilter, this.evaluationTemplate.id, {
					rollback: true
				})
				this.refreshList()
			}
		},
		async statisticsGrade(grade) {
			// 最终按级内排行 - 开始统计
			await this.$api.student_evaluation.release(grade)
			this.refreshList()
		},
		async publishGrade(grade, notify) {
			// 最终按级内排行 - 公布
			await this.$confirm(
				'评估表公布后，学生将可看到所有评级，确定公布评估表？',
				`公布${this.$api.classgrade.grades.toText(grade)}评估表`,
				{
					confirmButtonText: '公布',
					cancelButtonText: '取消'
				}
			)
			await this.$api.student_evaluation.release(grade, {
				completed: true
			})
			if (notify) notify.close()
			this.refreshList()
		},
		async rollbackGrade(grade) {
			// 最终按级内排行 - 撤回
			await this.$confirm(
				'评估表撤回后，学生看到的评级将一并撤回，确定撤回评估表？',
				`撤回${this.$api.classgrade.grades.toText(grade)}评估表`,
				{
					confirmButtonText: '撤回',
					cancelButtonText: '取消'
				}
			)
			await this.$api.student_evaluation.release(grade, {
				rollback: true
			})
			this.refreshList()
		},
		setScrollBar() {
			var el_table_wrapper = $('.el-table__body-wrapper')
			var el_table_body = $('.el-table__body')
			var scrollbar = $('.scrollbar')
			var dragbar = $('.dragbar')
			var l3_indicator_fixed = $('#l3-indicator_fixed')
			var l3_indicator = $('.l3-indicator')

			// TODO 获取到数据后再执行
			l3_indicator_fixed.css('width', el_table_wrapper.width() + 'px')
			l3_indicator.css('width', el_table_body.width() + 'px')

			var dragbar_width = (el_table_wrapper.width() / el_table_body.width()) * 100
			var table_canmove = el_table_body.width() - el_table_wrapper.width()

			if (dragbar_width >= 100) {
				// 无需滚动条
				scrollbar.css('display', 'none')
				return
			} else {
				scrollbar.css('display', 'flex')
			}

			dragbar.css('width', dragbar_width + '%')

			scrollbar.css('width', el_table_wrapper.width() + 'px')
			//滚动条可滚动距离
			var dragbar_canmove = scrollbar.width() - dragbar.width()
			dragbar.mousedown(function (e) {
				//鼠标按下时X坐标
				mousedown_x = e.pageX
				dragbarpressdown_position = dragbar.position().left

				$(document).mousemove(function (e) {
					//鼠标滚动时X坐标
					mousemove_x = e.pageX
					//鼠标拖拽距离按下时的距离
					dragbar_offsetX = dragbarpressdown_position + (mousemove_x - mousedown_x)
					//滚动条距离父容器剩余距离
					dragbar_position_end = dragbar_canmove - dragbar_offsetX

					l3_indicator_fixed.attr('class', '')

					//如果滚动条滚动距离小于等于0固定到最左边
					if (dragbar_offsetX <= 0) {
						l3_indicator_fixed.attr('class', 'shadow-right')
						dragbar_offsetX = 0
						dragbar_position_end = dragbar_canmove
					}
					//如果滚动条滚动距离超出表格宽度固定到表格最右边
					else if (dragbar_position_end <= 0) {
						l3_indicator_fixed.attr('class', 'shadow-left')
						dragbar_offsetX = dragbar_canmove
						dragbar_position_end = 0
					}

					//设置滚动条位移
					dragbar.css('transform', 'translateX(' + dragbar_offsetX + 'px)')

					el_table_wrapper.scrollLeft((table_canmove * dragbar.position().left) / dragbar_canmove)
				})
			})

			el_table_wrapper.scroll(function () {
				l3_indicator.css('transform', 'translateX(-' + el_table_wrapper.scrollLeft() + 'px)') // 仿写三级指标跟随 el_table_wrapper 移动
				dragbar.css(
					'transform',
					'translateX(' + dragbar_canmove * (el_table_wrapper.scrollLeft() / table_canmove) + 'px)'
				)
			})

			//鼠标松手时重置鼠标按下坐标
			$(document).mouseup(function () {
				$(document).off('mousemove')
				mousedown_x = 0
			})
		},
		handleScroll() {
			if (!$('.el-table').length) return

			// table 仿写三级指标 漂浮条件
			if ($(window).scrollTop() > $('.el-table__header-wrapper tr:last').offset().top) {
				$('#l3-indicator_fixed').css('display', 'block')
			} else {
				$('#l3-indicator_fixed').css('display', 'none')
			}
		}
	},
	deactivated() {
		// 清理事件
		window.removeEventListener('scroll', this.handleScroll)
		clearInterval(statisticsTimer)
		statisticsTimer = null
	}
}
</script>
<style lang="scss" scoped>
.evaluation-sheet {
	user-select: none;

	.notice {
		background: rgba(33, 167, 74, 0.1);
		border-radius: 4px;
		padding: 0 16px;
		height: 48px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin: 20px 20px 0;
		.content {
			color: #21a74a;
			display: flex;
			align-items: center;
			.icon {
				font-size: 20px;
				margin-right: 4px;
			}
		}
	}

	.filter-area {
		margin-top: 20px;
		margin-right: 20px;
		.el-form {
			display: flex;
		}
		.button-group {
			margin-left: auto;
			.upload-demo {
				display: inline-block;
				margin: 0 10px;
			}
		}
		.el-form-item {
			margin-bottom: 20px;
		}
	}
	.table-block {
		min-height: 526px;
	}
	/deep/.el-table {
		// 覆盖原生滚动条
		margin-bottom: -18px;
		/* 设置滚动条的样式 */
		::-webkit-scrollbar {
			visibility: hidden;
		}
		.el-table__body-wrapper {
			padding-bottom: 0;
		}
		.hidden-columns {
			visibility: visible;
			z-index: 9;
			top: 20%;
			left: 50%;
		}
		tbody {
			tr {
				td,
				.cell {
					padding: 0 !important;
					.table-cell {
						min-height: 50px;
						padding: 12px 10px;
						display: flex;
						align-items: center;
						justify-content: center;
						&.final-grade {
							padding: 0;
							margin: 0 auto;
							min-height: 32px;
							height: 32px;
							width: 80px;
							&:hover {
								border: 1px solid #dcdfe6;
								border-radius: 2px;
							}
						}
					}
				}
				td:nth-child(1) {
					.table-cell {
						padding-left: 40px;
						justify-content: flex-start;
					}
				}
			}
		}
		tbody,
		thead {
			th {
				border-top: none;
				.statistics {
					color: #21a74a;
					font-size: 12px;
					text-decoration: underline;
				}
			}
			tr {
				&.hover-row {
					td {
						background-color: initial;
					}
				}
				&:nth-child(1) {
					th:nth-child(1) {
						padding-left: 30px;
					}
				}
				th:nth-child(1) {
					padding-left: 0;
				}
				td:last-child {
					padding-right: 0;
				}
			}
		}
		.set-grade,
		.hover {
			cursor: pointer;
			&:hover {
				background: #f8fcf9;
			}
		}
		.set-grade,
		.not-grade {
			color: #ccc;
		}
		.not-grade {
			cursor: text;
			&:hover {
				background: initial !important;
			}
		}
	}
	#l3-indicator_fixed {
		display: none;
		transform: translateX(1px);
		font-weight: 700;
		z-index: 5;
		position: fixed;
		top: 0;
		color: #333;
		box-sizing: border-box;
		box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.12);
		overflow-x: hidden;
		&.shadow-right {
			.student {
				box-shadow: none;
			}
		}
		&.shadow-left {
			.final-rating {
				box-shadow: none;
			}
		}
		.student,
		.final-rating {
			position: absolute;
			top: 0;
			height: 100%;
			z-index: 4;
			display: flex;
			box-shadow: 0 0 10px rgba(0, 0, 0, 0.12);
		}
		.student {
			left: 0;
			padding-left: 40px;
			box-sizing: border-box;
			text-align: left !important;
			align-items: center;
			overflow-x: hidden;
			overflow-y: hidden;
		}
		.final-rating {
			right: 0;
			flex-direction: column;
			justify-content: center;
			border-right: 1px solid #ebeef5;
			box-sizing: border-box;
			.statistics {
				color: #21a74a;
				font-size: 12px;
				text-decoration: underline;
			}
		}
		.student,
		.final-rating,
		.cell {
			border-right: 1px solid #ebeef5;
			text-align: center;
			background: #f8fcf9;
		}
		.l3-indicator_wrapper {
			.l3-indicator {
				padding: 0 100px 0 150px; // el-table 左右漂浮元素宽度
				position: relative;
				z-index: 3;
				display: flex;
				box-sizing: border-box;
				.cell {
					flex: 1;
					display: flex;
					justify-content: center;
					align-items: center;
					padding: 12px 10px;
					line-height: 23px;
				}
			}
		}
	}
	.scrollbar {
		// 覆盖原生滚动条
		margin-bottom: -18px;
		z-index: 9;
		position: sticky;
		bottom: 0;
		width: 100%;
		background: #fafafa;
		border-top: 1px solid #ebeef5;
		height: 16px;
		display: flex;
		align-items: center;
		.dragbar {
			background: rgba(0, 0, 0, 0.2);
			height: 8px;
			display: block;
			width: 20%;
			content: '';
			border-radius: 4px;
			&:active {
				background-color: rgba(0, 0, 0, 0.4);
			}
		}
	}
	/deep/.el-dialog {
		border-radius: 8px;
		.el-dialog__title {
			color: #21a74a;
		}
	}
	/deep/.final-rating-dialog {
		.el-dialog__body {
			padding: 20px;
		}
		.content {
			.tips {
				background: rgba(33, 167, 74, 0.1);
				border-radius: 4px;
				height: 36px;
				display: flex;
				align-items: center;
				font-size: 12px;
				color: #21a74a;
				padding: 0 12px;
				margin-bottom: 20px;
				.icon {
					font-size: 18px;
					margin-right: 6px;
				}
			}
			.item {
				margin-bottom: 12px;
				padding: 12px 16px;
				background-color: #f6f6f6;
				border-radius: 4px;
				&:last-of-type {
					margin: 0;
				}
				.basic {
					display: flex;
					align-items: center;
					justify-content: space-between;
					.grade {
						font-size: 16px;
						color: #333;
						display: flex;
						align-items: center;
						.icon {
							font-size: 24px;
							margin-right: 4px;
							color: #21a74a;
						}
					}
					.statistic-btn {
						background: rgba(33, 167, 74, 0.1);
						color: #21a74a;
						border-color: rgba(33, 167, 74, 0.1);
						&.is-disabled {
							opacity: 0.5;
						}
					}
					.in-statistics {
						width: 88px;
						height: 36px;
						line-height: 36px;
						text-align: center;
						color: #cccccc;
					}
				}
				.extra {
					padding-top: 12px;
					margin-top: 12px;
					border-top: 1px solid #ebeef5;
					color: #999;
					font-size: 12px;
				}
			}
		}
	}
	/deep/.prize-dialog {
		.content {
			.item {
				padding: 0 16px 16px;
				background: #f6f6f6;
				border-radius: 4px;
				&:not(:first-of-type) {
					margin-top: 12px;
				}
				.top {
					height: 48px;
					display: flex;
					align-items: center;
					.prize-name {
						display: flex;
						align-items: center;
						color: #21a74a;
						.icon {
							font-size: 18px;
						}
					}
					.vertical-split {
						height: 16px;
						width: 1px;
						background: #d8d8d8;
						margin: 0 16px;
					}
					.prize-standard {
						color: #999;
						font-size: 12px;
					}
				}
				.name-list {
					span {
						display: inline-block;
						border: 1px solid #cccccc;
						background: #eee;
						border-radius: 2px;
						padding: 2px 8px;
						margin: 8px 8px 0 0;
					}
				}
				.empty {
					color: #ccc;
					text-align: center;
					margin-bottom: 12px;
				}
			}
		}
		.el-dialog__footer {
			padding-top: 0;
			text-align: center;
		}
	}
	/deep/.evaluation-sheet-drawer {
		.el-drawer__header {
			font-size: 18px;
			color: #333;
		}
		.el-drawer__body {
			overflow-y: auto;
			padding-bottom: 150px;
			.drawer-content {
				position: relative;
				.rating-rules {
					border-radius: 4px;
					margin: 0 40px 20px;
					background-color: rgba(33, 167, 74, 0.06);
					.rating-rules-header {
						display: flex;
						align-items: center;
						height: 80px;
						.icon {
							display: block;
							font-size: 32px;
							color: #21a74a;
							margin: 0 20px;
						}
						.text {
							.name,
							.describe {
								display: block;
								color: #666;
							}
							.name {
								margin-bottom: 4px;
								font-size: 18px;
								color: #333;
							}
						}
					}
				}
				// 共用
				.rating-rules-content {
					padding: 16px 20px;
					border-top: 1px solid rgba(33, 167, 74, 0.1);
					display: flex;
					&.homework {
						background-color: #fafafa;
						border-top: none;
						margin-left: 40px;
						.rating-rules-details {
							flex: 1;
							li {
								color: #999;
								&.reach {
									color: #21a74a;
								}
								.reach {
									float: right;
									.icon {
										font-size: 18px;
									}
								}
							}
						}
					}
					.title {
						height: 32px;
						line-height: 32px;
						color: #666;
					}
					.rating-rules-details {
						margin: 0;
						margin-left: 30px;
						// list-style-type: none;
						li {
							color: #21a74a;
							height: 32px;
							line-height: 32px;
						}
					}
				}
				.performance-section {
					padding: 0 40px;
					.performance-block {
						border: 1px solid #ebeef5;
						margin-bottom: 20px;
						border-radius: 4px;
						.performance-header {
							background-color: #fafafa;
							height: 40px;
							text-align: center;
							line-height: 40px;
							color: #333;
							border-bottom: 1px solid #ebeef5;
						}
						.content {
							&.rules {
								display: flex;
								.reduce {
									border-right: 1px solid #f6f6f6;
									.score {
										color: #f13048;
									}
								}
								.plus {
									.score {
										color: #21a74a;
									}
								}
								.reduce,
								.plus {
									flex: 1;
									color: #666;
								}
								.item {
									height: 40px;
									padding: 0 16px;
									display: flex;
									justify-content: space-between;
									align-items: center;
								}
							}
							&.record {
								.item {
									height: 40px;
									padding: 0 30px;
									display: flex;
									align-items: center;
									&:not(:first-child) {
										border-top: 1px solid #f6f6f6;
									}
									.name,
									.count,
									.score {
										padding-left: 10px;
									}
									.name {
										width: 260px;
										color: #666;
									}
									.count {
										width: 120px;
										color: #999;
									}
									.score {
										width: 80px;
										&.reduce {
											color: #f13048;
										}
										&.plus {
											color: #26bf3d;
										}
									}
								}
							}
						}
						.performance-footer {
							background-color: #fafafa;
							border-top: 1px solid #ebeef5;
							height: 40px;
							padding: 0 30px;
							display: flex;
							align-items: center;
							color: #333;
							.footer-text {
								width: 380px;
								padding-left: 10px;
							}
							.total-score {
								width: 80px;
								padding-left: 10px;
							}
						}
						.empty-data {
							min-height: 200px;
							line-height: 200px;
							color: #e0e0e0;
							font-size: 14px;
						}
					}
				}
				.el-form {
					padding-right: 40px;
					.record {
						.el-form-item__content {
							line-height: normal;
							.recordItem {
								padding: 12px 20px;
								background-color: #fafafa;
								border-radius: 4px;
								display: flex;
								align-items: center;
								justify-content: space-between;
								margin-bottom: 12px;
								.info {
									.date {
										display: block;
										color: #999;
									}
									.name {
										display: flex;
										align-items: center;
										color: #666;
										&.event {
											cursor: pointer;
											&:hover {
												text-decoration: underline;
											}
											.icon {
												visibility: visible;
											}
										}
										.icon {
											visibility: hidden;
											font-size: 18px;
											margin-left: 4px;
										}
									}
								}
								.score {
									color: #3bd051;
								}
								.grade {
									color: #f13048;
								}
							}
						}
					}
					.empty-data {
						margin-top: 200px;
					}
				}
				.drawer-footer {
					background-color: white;
					z-index: 99;
					position: fixed;
					bottom: 0;
					width: 560px;
					border-top: 1px solid #eee;
					padding: 20px 0;
					margin: 0 20px;
					text-align: center;
					.grade {
						margin-bottom: 20px;
						font-size: 18px;
						line-height: 40px;
						height: 40px;
						text-align: left;
						color: #666;
					}
					.el-button {
						width: 200px;
					}
				}
			}
		}
	}
	.publish {
		margin-top: 20px;
		padding: 20px 0 20px;
		text-align: center;
	}
	.rollback {
		background-color: #ffac2d;
		border-color: #ffac2d;
	}
	/deep/.import-failed-dialog {
		.el-dialog__header {
			color: #333;
			font-size: 18px;
			.icon {
				color: #ff1f3b;
				font-size: 24px;
				margin-right: 4px;
			}
		}
		.el-dialog__footer {
			text-align: center;
		}
	}
}
.evaluation-sheet-dropdown {
	.el-dropdown-menu__item {
		width: 40px;
		text-align: center;
	}
}
.statistics-btn {
	cursor: pointer;
	height: 32px;
	line-height: 32px;
	padding: 0 16px;
	border-radius: 4px;
	background-color: #eeeeee;
	&.publish {
		background-color: #21a74a;
		color: white;
	}
}
</style>
